import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private currencyLocalSubject = new BehaviorSubject<any>(null);
  currencyLocalSubject$ = this.currencyLocalSubject.asObservable();

  setCurrencySubject(value: any) {
    this.currencyLocalSubject.next(value);
  }

  private countrylocalSubject = new BehaviorSubject<any>(null);
  countrylocalSubject$ = this.countrylocalSubject.asObservable();

  setCountrySubject(value: any) {
    this.countrylocalSubject.next(value);
  }

  private countryCodelocalSubject = new BehaviorSubject<any>(null);
  countryCodelocalSubject$ = this.countryCodelocalSubject.asObservable();

  setCountryCodeSubject(value: any) {
    this.countryCodelocalSubject.next(value);
  }

  private travelAgentSubject = new BehaviorSubject<any>(null);
  travelAgentSubject$ = this.travelAgentSubject.asObservable();

  setTravelAgentSubject(value: any) {
    this.travelAgentSubject.next(value);
  }

  private affiliateIdSubject = new BehaviorSubject<any>(null);
  affiliateIdSubject$ = this.affiliateIdSubject.asObservable();

  setAffiliateIdSubject(value: any) {
    this.affiliateIdSubject.next(value);
  }

  private customerProfileSubject = new BehaviorSubject<any>(null);
  customerProfileSubject$ = this.customerProfileSubject.asObservable();

  setCustomerProfileSubject(value: any) {
    this.customerProfileSubject.next(value);
  }

  private webSourceSubject = new BehaviorSubject<any>(null);
  webSourceSubject$ = this.webSourceSubject.asObservable();

  setWebSourceSubject(value: any) {
    this.webSourceSubject.next(value);
  }

  private couponSubject = new BehaviorSubject<any>(null);
  couponSubject$ = this.couponSubject.asObservable();

  setCouponSubject(value: any) {
    this.couponSubject.next(value);
  }
}
